import React, { useState, useEffect } from 'react';
import axios from 'axios';

const StaffDetails = ({ formData, onFormDataChange }) => {
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch trainers by branch
  useEffect(() => {
    const fetchTrainers = async () => {
      if (!formData.branch) return;
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/trainers?branch=${encodeURIComponent(formData.branch)}`
        );
        setTrainers(response.data || []);
        setError('');
      } catch (err) {
        console.error('Error fetching trainers:', err);
        setError('Failed to fetch trainers');
        setTrainers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTrainers();
  }, [formData.branch]);

  const handleStaffSelection = (field, selectedName) => {
    const selectedTrainer = trainers.find(
      (trainer) => trainer.emp_name === selectedName
    );

    if (field === 'mentorName') {
      onFormDataChange((prev) => ({
        ...prev,
        mentorName: selectedName,
        mentorId: selectedTrainer ? selectedTrainer.emp_id.toString() : '',
        mentorNumber: selectedTrainer ? selectedTrainer.contact_num || '' : ''
      }));
    } else {
      const idField = field.replace('Name', 'Id');
      onFormDataChange((prev) => ({
        ...prev,
        [field]: selectedName,
        [idField]: selectedTrainer ? selectedTrainer.emp_id.toString() : ''
      }));
    }
  };

  return (
    <div className="form-section">
      <div className="section-content">
        {/* Branch Info */}
        {/* <div className="form-row">
          <div className="form-group full-width">
            <label className="label">Branch</label>
            <input
              type="text"
              value={formData.branch || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        </div> */}

        {error && (
          <div
            style={{
              backgroundColor: '#f8d7da',
              color: '#721c24',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '10px'
            }}
          >
            {error}
          </div>
        )}

        {/* Mentor Details */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">Mentor Name</label>
            <input
              type="text"
              value={formData.mentor || formData.mentorName || ""}
              readOnly
              className="input"
              style={{ backgroundColor: "#f5f5f5", cursor: "not-allowed" }}
            />
          </div>


          <div className="form-group">
            <label className="label">Mentor Number</label>
            <input
              type="text"
              value={formData.mentorNumber || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        </div>

        {/* Staff 2 Details */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">Staff Name 1</label>
            <input
              type="text"
              value={formData.staffName1 || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label className="label">Staff Name 2</label>
            <select
              value={formData.staffName2 || ''}
              onChange={(e) =>
                handleStaffSelection('staffName2', e.target.value)
              }
              className="input select"
              disabled={loading || trainers.length === 0}
            >
              <option value="">
                {loading
                  ? 'Loading trainers...'
                  : trainers.length === 0
                    ? 'No trainers available'
                    : 'Select Staff 2'}
              </option>
              {trainers.map((t) => (
                <option key={t.emp_id} value={t.emp_name}>
                  {t.emp_name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="label">Staff Name 3</label>
            <select
              value={formData.staffName3 || ''}
              onChange={(e) =>
                handleStaffSelection('staffName3', e.target.value)
              }
              className="input select"
              disabled={loading || trainers.length === 0}
            >
              <option value="">
                {loading
                  ? 'Loading trainers...'
                  : trainers.length === 0
                    ? 'No trainers available'
                    : 'Select Staff 3'}
              </option>
              {trainers.map((t) => (
                <option key={t.emp_id} value={t.emp_name}>
                  {t.emp_name}
                </option>
              ))}
            </select>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StaffDetails;
